import { SCREEN } from '../../styles/variables/screen';

type Query = ({ width }: { width: number }) => boolean;

const QUERIES: Record<'MOBILE_PORTRAIT' | 'MOBILE' | 'TABLET' | 'DESKTOP', Query> = {
  MOBILE_PORTRAIT: ({ width }) => width < SCREEN.screenXs,
  MOBILE: ({ width }) => width < SCREEN.screenS,
  TABLET: ({ width }) => width >= SCREEN.screenS && width < SCREEN.screenM,
  DESKTOP: ({ width }) => width >= SCREEN.screenM,
};

export default QUERIES;
